import { defineComponent, ref, onMounted, onBeforeMount, computed } from "vue";
import { V as VaConfig } from "../../va-config/VaConfig-785c45a1.mjs";
import { u as useBem } from "../../../composables/useBem-a19cd502.mjs";
const _sfc_main = defineComponent({
  name: "VaSkeletonGroup",
  components: {
    VaConfig
  },
  props: {
    color: { type: String, default: "backgroundElement" },
    delay: { type: Number, default: 100 },
    animation: { type: String, default: "pulse" },
    lines: { type: Number, default: 1 },
    lineGap: { type: String, default: "8px" },
    lastLineWidth: { type: [String], default: "75%" }
  },
  setup(props) {
    const doShow = ref(false);
    let timeoutId;
    onMounted(() => {
      timeoutId = setTimeout(() => {
        doShow.value = true;
      }, props.delay);
    });
    onBeforeMount(() => {
      clearTimeout(timeoutId);
    });
    const bem = useBem("va-skeleton-group", () => ({
      hidden: doShow.value === false
    }));
    return {
      doShow,
      bem,
      config: computed(() => ({ ...props, delay: 0 }))
    };
  }
});
export {
  _sfc_main as _
};
//# sourceMappingURL=VaSkeletonGroup.vue_vue_type_script_lang-47fcf170.mjs.map
